<canvas
  *ngIf="imageArr.length > 0"
  baseChart
  [data]="doughnutChartData"
  [type]="doughnutChartType"
  [options]="chartOptions"
  [plugins]="plugins"
  [width]="puppeteerApp && qReport ? '750' : puppeteerApp && zReport ? '750' : puppeteerApp ? '550' : ''"
></canvas>
